import { Select } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";

const FilterModeSelectorMobile = ({
  value,
  onChange,
  borderColor,
  disabled,
  level,
}) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Select
      value={value}
      onChange={onChange}
      style={{
        position: "absolute",
        bottom: "-25px",
        left: -4,
        zIndex: 5,
      }}
      data={[
        {
          value: "and",
          label: lang.table.toolbar.filter.conditions.and,
        },
        {
          value: "or",
          label: lang.table.toolbar.filter.conditions.or,
        },
      ]}
      comboboxProps={{ zIndex: 1400, offset: 2, shadow: "sm" }}
      w={58}
      size={"xs"}
      styles={{
        input: {
          borderColor,
        },
      }}
      readOnly={disabled}
    />
  );
};

export default FilterModeSelectorMobile;
